import { render, staticRenderFns } from "./buyChoice.vue?vue&type=template&id=21960454&scoped=true&"
import script from "./buyChoice.vue?vue&type=script&lang=js&"
export * from "./buyChoice.vue?vue&type=script&lang=js&"
import style0 from "./buyChoice.vue?vue&type=style&index=0&id=21960454&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21960454",
  null
  
)

export default component.exports